// @flow
import moment from 'moment'

// Types
import type { ServiceHours } from '../../../models/step'

type Value = {
  start_time: ?string,
  end_time: ?string,
}

/**
 * Utility function that helps to build service hours object
 * @param  {Object}
 * @return {Object}
 */
const buildServiceHours = (val: ?Value): ?ServiceHours => {
  if (val && val.start_time && val.end_time) {
    return {
      startTime: moment(val.start_time, 'HH:mm:ss'),
      endTime: moment(val.end_time, 'HH:mm:ss'),
    }
  }
  return null
}

export default buildServiceHours
